export const sanitizeUserInput = (input: string | number | undefined) => {
  return input?.toString()?.replace(/\s+/g, " ")?.trim();
};
